import { FixaSkeleton } from "@coworker/apprestructured/src/shared/wrappers/FixaSkeleton/FixaSkeleton";
import { FixaListView } from "@coworker/apprestructured/src/shared/wrappers/FixaListView/FixaListView";

export const LoadingLogsAndComments = ({ id }: { id: string }) => {
  return (
    <FixaListView id={id}>
      <FixaSkeleton height={"90px"} />
    </FixaListView>
  );
};
